import { useUserAuth } from '@/state/cookieContext';

/**
 * recoil user state를 return 합니다.
 */
export default function useUserState() {
  return useUserAuth();
}
